import PropTypes from 'prop-types'
import React from 'react'

import { Wrapper, Loader } from './styles'

export const btnTypes = {
    SUCCESS: 'success',
    DANGER: 'danger',
    PRIMARY: 'primary',
}

export const colorVariant = {
    [btnTypes.SUCCESS]: `var(--oh-green)`,
    [btnTypes.DANGER]: `var(--oh-orange)`,
    [btnTypes.PRIMARY]: `var(--oh-blue)`,
}

const Button = props => {
    const { text, isLoading, children } = props

    const content = isLoading ? (
        <Loader src="/img/checklist/spinner.gif" />
    ) : (
        text || children
    )

    return <Wrapper {...props}>{content}</Wrapper>
}

Button.propTypes = {
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    outlined: PropTypes.bool,
    type: PropTypes.oneOf(Object.values(btnTypes)),
    text: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.any, // pass either text or children. text has higher priority
}

export default Button
